import React from "react";

import "./message-box.css";

function MessageBox({message, type}) {
    return(
        <div className="main-box">
            <div className={`message-img ${type}`}></div>
            <div className={`message-text ${type}`}>{message}</div>
        </div>
    )
}

export default MessageBox;